import { baseQuery } from "../../app/baseQuery";
import { apiTags } from 'app/store/apiTags';
import { baseApi } from 'app/baseApi';

const apiPrefix = 'vendor';
export const vendorApi = baseApi.injectEndpoints({
    reducerPath: 'vendorApi',
    tagTypes: [apiTags.VENDOR],
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getVendors: builder.query({
            query: (clientId) => `${apiPrefix}/all?clientId=${clientId ?? 0}`,
            providesTags: [apiTags.VENDOR],
        }),
        getVendorById: builder.query({
            query: (spId) => `${apiPrefix}/${spId}`,
            providesTags: (result, error, spId) =>
                result ?
                    [{ type: apiTags.VENDOR, id: spId }] :
                    [{ type: apiTags.VENDOR, id: 'LIST' }],
        }),
        addVendor: builder.mutation({
            query: (vendor) => ({
                url: `${apiPrefix}`,
                method: "POST",
                body: vendor
            }),
            invalidatesTags: [apiTags.VENDOR],
        }),
    }),
});

export const {
    useGetVendorsQuery,
    useAddVendorMutation,
    useGetVendorByIdQuery
} = vendorApi;
